<!-- 互动直播 -->
<template>
  <div class="warp">
    <div class="banner">
      <p>全新直播系统</p>
      <span>
        带您进入直播+的黄金时代
        <br />助您搭建自己的直播+平台
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="live1">
      <div class="title">
        直播创造价值 粉丝和流量在哪里
        <br />市场和价值就在哪里
      </div>
      <div class="item">
        <img src="../../assets/images/page45.jpg" />
        <div>
          <p>
            月活跃用户
            <i>4500</i>万
          </p>
          <p>
            <i>562</i>场周杰伦
            <i>8</i>万人演唱会
          </p>
        </div>
      </div>
      <div class="item">
        <img src="../../assets/images/page46.jpg" />
        <div>
          <p>
            手机端用户
            <i>1000</i>万
          </p>
          <p>
            <i>200</i>场NBA
            <i>5</i>万人现场赛事
          </p>
        </div>
      </div>
      <div class="item">
        <img src="../../assets/images/page47.jpg" />
        <div>
          <p>
            用户每月在线总时长
            <i>130</i>亿分钟
          </p>
          <p>
            平均每人每天观看直播
            <i>117</i>分钟
          </p>
        </div>
      </div>
    </div>
    <div class="live2">
      <div class="item">
        <div class="left">
          <img src="../../assets/images/icon75.png" />
        </div>
        <div class="right">
          <span>某主播红人直播</span>
          <p>
            同时在线人数
            <i>10W+</i>月收入
            <i>100</i>万
          </p>
        </div>
      </div>
      <div class="item" style="background-color: #fef8f0;">
        <div class="left">
          <img src="../../assets/images/icon76.png" />
        </div>
        <div class="right">
          <span>
            直播频道日活跃主播红人
            <i>3000</i>人
          </span>
          <p>
            活跃频道季度总收入
            <i>10亿元</i>
          </p>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <img src="../../assets/images/icon77.png" />
        </div>
        <div class="right">
          <span>活跃频道不可计数</span>
          <p>
            年净利润
            <i>8000W+</i>
          </p>
        </div>
      </div>
    </div>
    <div class="live3">
      <div class="title">
        <span>互动直播系统是什么</span>
        <p>互动直播系统是一款让用户通过手机观看直播、连麦、交流打赏，传播分享每一个直播精彩瞬间的流媒体直播系统。它既能是独立的手机互动直播APP，也能在您原有的平台基础上嵌入直播，搭建属于您的“直播+”平台。</p>
      </div>
      <swiper :options="swiperOption" class="swiper-container">
        <!-- slides -->
        <swiper-slide class="swiper-item">
          <img class="swiper-img" src="../../assets/images/page48.jpg" />
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <img class="swiper-img" src="../../assets/images/page49.jpg" />
        </swiper-slide>
        <!-- Optional controls ,显示小点-->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="live4">
      <div class="title">2种模式 让你抓住直播的风口</div>
      <div class="item">
        <div class="t1">
          <i></i>
          <span>01</span>
          <i></i>
        </div>
        <div class="t2">
          <img src="../../assets/images/page51.jpg" />
        </div>
        <div class="t3">搭建专业的独立直播平台</div>
        <div class="t4">
          <span>发展方向:</span>
          <p>以直播主营业务,发展专业的直播平台，如秀场直播、游戏直播等</p>
        </div>
        <div class="t4">
          <span>绿茶提供:</span>
          <p>手机直播APP(安卓+IOS)+PC后台管理</p>
        </div>
        <div class="t4">
          <span></span>
          <b>自主创建品牌&nbsp;&nbsp;独立运营平台&nbsp;&nbsp;独揽所有收益</b>
        </div>
      </div>
      <div class="item">
        <div class="t1">
          <i></i>
          <span>02</span>
          <i></i>
        </div>
        <div class="t2">
          <img src="../../assets/images/page52.jpg" />
        </div>
        <div class="t3">现有垂直网站/平台+直播</div>
        <div class="t4">
          <span>发展方向:</span>
          <p>现有平台嵌入直播；如电商平台+直播、社交平台+直播、在线教育+直播等</p>
        </div>
        <div class="t4">
          <span>绿茶提供:</span>
          <p>互动直播模块(安卓+IOS)无缝嵌入现有平台APP</p>
        </div>
        <div class="t4">
          <span></span>
          <b>平台快速引流&nbsp;&nbsp;增加在线互动&nbsp;&nbsp;促进销售转化</b>
        </div>
      </div>
    </div>
    <div class="live3 live5">
      <div class="title" style="padding-top:1rem;">
        <span>
          10大直播解决方案
          <br />带您快速进入“直播+”时代
        </span>
      </div>
      <swiper :options="swiperOption" class="swiper-container" style="padding-top:1.1rem;">
        <!-- slides -->
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+新闻资讯解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive01.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统咨询/新闻平台向直播+新闻/资讯模式转型
            </h4>
            <h5>新闻事件都有一定的突发性，传统的新闻播报形式难免不及时。借助直播技术，让所有人都有机会成为“云记者”，第一时间记录传递最新最快新闻资讯，赋予新闻资讯直播时代的新意义。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+互联网金融解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive02.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助互联网金融平台向直播+互联网模式转型
            </h4>
            <h5>直播让互联网金融平台用户实时掌握最新时代动态，站在经济最前沿的金融战场。在线喊单、讲盘等功能，范围几乎能全面涵盖所有金融业务，让您在金融营销变局中立于不败之地。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+众筹路演解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive03.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统众筹平台向直播+众筹路演模式转型
            </h4>
            <h5>直播赋予了众筹路演新含义，让原本仅依靠文字/图片/视频等单向展示项目的方式成为实时性、直观性、互动性更强的交互模式。实时互动观看路演，边直播边众筹，深度撮合众筹成功。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+在线教育解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive04.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统在线教育平台向直播+在线教育模式转型
            </h4>
            <h5>直播，将传统线下老师督促学生完成学习任务、检验学习质量、学生反馈学习情况提出疑问等双向互动很好地在线上进行统一，形成线上教育互动，形成在线教育行业发展新机遇。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+O2O解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive05.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统O2O平台向直播+O2O模式转型
            </h4>
            <h5>商家利用线上直播，真实还原线下场景，不论美食/休闲/购物/娱乐/酒店/生活服务，均能通过直播打造业内优势，促进线上到线下导流，真正形成O2O从线上到线下的良性商业闭环。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+旅游解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive06.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统旅游平台向直播+旅游模式转型
            </h4>
            <h5>打破原本旅游平台仅靠图片、文字对旅游这种个人体验项目描述上的单一感，加入直播那种身临其境、所见即所得的当下体验感，优化用户体验，让平台上所有用户流量更有机会得以变现。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+电商解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive07.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统电商平台向直播+电商模式转型
            </h4>
            <h5>用户不退出直播情况下，就能直接下单主播推荐产品。“边看边买”的直播模式，丰富了电商的产品展示内容，更好的将直播内容转化为用户的电商购买行为，开启剁手新模式。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+社交解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive08.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统社交平台向直播+社交模式转型
            </h4>
            <h5>直播用更直观的方式自我展示，大大降低用户之间社交门槛。重叠观看的直播内容让社交平台更易于深入挖掘用户习惯，扩大平台社交属性的同时聚集活跃流量人气。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+游戏解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive09.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统游戏平台向直播+游戏模式转型
            </h4>
            <h5>实时直播各类精彩游戏对战，互动参与各类线上工会活动，赞助战队等，快速聚集游戏平台人气形成游戏主播粉丝经济效应，实现游戏平台盈利最大化。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list5">
            <h2>直播+娱乐解决方案</h2>
            <h3>
              <img src="../../assets/images/interactionLive10.png" />
            </h3>
            <h4>
              借助直播优势，
              <br />帮助传统娱乐平台向直播+娱乐模式转型
            </h4>
            <h5>利用直播特点，对娱乐平台流量利用率不足进行完美补充，增加平台粉丝黏性，使客户的互动效率最大化，最终实现消费/购买转化或投放平台广告资源。</h5>
            <h6>微信客服>></h6>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="live6">
      <div class="title">绿茶直播能为您带来什么？</div>
      <ul class="list6">
        <li>
          <img src="../../assets/images/page55.jpg" />
          <span>随时移动直播</span>
        </li>
        <li>
          <img src="../../assets/images/page56.jpg" />
          <span>互动交流打赏</span>
        </li>
        <li>
          <img src="../../assets/images/page57.jpg" />
          <span>轻松社交分享</span>
        </li>
        <li>
          <img src="../../assets/images/page58.jpg" />
          <span>边直播边购物</span>
        </li>
        <li>
          <img src="../../assets/images/page59.jpg" />
          <span>数据统计分析</span>
        </li>
      </ul>
    </div>
    <div class="live6 live7">
      <div class="title">绿茶互动直播 直播平台搭建</div>
      <ul class="list7">
        <li>
          <img src="../../assets/images/interactionLive11.png" />
          <div>
            <span>跨平台互动</span>
            <p>支持安卓、iOS主流平台开播、观看及互通；支持接入微信公众号；支持一对多；多对多的互动直播</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/interactionLive12.png" />
          <div>
            <span>完美的互动直播体验</span>
            <p>拥有与映客、QQ一样卓越的音视频质量；支持同时收取6路语音，支持最高720P高清视频，保证高质量音视频通信</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/interactionLive13.png" />
          <div>
            <span>品牌合作 流量分发</span>
            <p>与腾讯云、暴风科技合作，品牌合作直播质量有保障。绿茶提供统一大流量订购,流量资费更优惠结合录播可实现存储、转码等</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/interactionLive14.png" />
          <div>
            <span>高并发解决方案</span>
            <p>绿茶针对十万、百万、千万高并发有不同高并发解决方案，可助您轻松应对在线直播平台瞬间高并发业务</p>
          </div>
        </li>
        <li>
          <img src="../../assets/images/interactionLive15.png" />
          <div>
            <span>系统安全稳定</span>
            <p>超低延时，内容秒传，端到端延时小于400ms，抗800ms的网络抖动，全面保障平台稳定运行</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="live8">
      <div class="title">
        <span>直播 您的下一个营销阵地</span>
        <p>直播营销风头正劲，粉丝效应引领下一波营销革命</p>
      </div>
      <van-tabs type="card" color="#4f67fe">
        <van-tab title="品牌+发布会+直播">
            <div class="item">
                <h2>小米直播：小米Max超耐久无聊待机直播</h2>
                <p>小米max新品发布超久待机直播共19天吸引了近3000万人观看,利用抽取评论送手机吸引用户持续关注，真正用结合了直播特性的策略营销传递了小米max超长续航的产品理念</p>
                <img src="../../assets/images/page60.png">
            </div>
        </van-tab>
        <van-tab title="品牌+明星+直播">
            <div class="item">
                <h2>小米直播：小米Max超耐久无聊待机直播</h2>
                <p>小米max新品发布超久待机直播共19天吸引了近3000万人观看,利用抽取评论送手机吸引用户持续关注，真正用结合了直播特性的策略营销传递了小米max超长续航的产品理念</p>
                <img src="../../assets/images/page60.png">
            </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="live8">
      <div class="title" style="padding:1rem 0 .2rem;">
        <span>直播平台如何流量变现?</span>
      </div>
      <img src="../../assets/images/page61.png" style="width:100%;margin-bottom:-1.1rem;">
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Tab, Tabs } from "vant";

Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "interactionLive",

  data() {
    return {
      swiperOption: {
        loop: true,
        speed: 500, //匀速时间
        autoplay: {
          delay: 300000000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination"
        }
        // slidesPerView: 4,
        // centeredSlides: true
      }
    };
  },
  mounted() {},

  methods: {}
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fbfbfc;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/interactionLiveBanner.jpg") no-repeat
      left top;
    background-size: 100% auto;
    height: 9.1rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #fff;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #0f67f9;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: .9rem;
      display: block;
    }
  }
  .live1 {
    width: 9.9rem;
    border-radius: 0.2rem;
    box-shadow: 0px 0px 100px 0px rgba(55, 68, 123, 0.11);
    background-color: #fff;
    margin: auto;
    margin-top: -2.2rem;
    .title {
      font-size: 0.5rem;
      text-align: center;
      padding-top: 1rem;
    }
    .item {
      padding-bottom: 0.6rem;
      img {
        width: 100%;
      }
      div {
        text-align: center;
        line-height: 0.7rem;
        p {
          margin: 0 2%;
          width: 44%;
          display: inline-block;
          background-image: linear-gradient(
            0deg,
            rgb(255, 124, 102) 0%,
            rgb(255, 199, 58) 0%,
            rgb(82, 103, 252) 0%,
            rgb(75, 131, 253) 58%,
            rgb(67, 159, 254) 100%
          );
          border-radius: 0.1rem;
          color: #fff;
          font-size: 0.28rem;
          white-space: nowrap;
          i {
            font-size: 0.36rem;
            color: #fcff00;
            font-style: italic;
            font-weight: 500;
            margin-right: 0.05rem;
          }
        }
      }
    }
  }
  .live2 {
    padding: 0.4rem 0 0.8rem;
    .item {
      height: 2.4rem;
      background-color: #eff8fe;
      margin-top: 0.3rem;
      display: flex;
      align-items: center;
      .left {
        width: 2.9rem;
        text-align: center;
        img {
          width: 2.7rem;
        }
      }
      .right {
        span {
          font-size: 0.4rem;
        }
        p {
          font-size: 0.36rem;
          color: #666;
        }
        i {
          color: red;
          font-style: italic;
          font-weight: 500;
          font-style: 0.42rem;
        }
      }
    }
  }
  .live3 {
    .title {
      padding: 0.3rem 0.4rem 0;
      text-align: center;
      span {
        font-size: 0.52rem;
      }
      p {
        font-size: 0.34rem;
        padding: 0.2rem 0;
        line-height: 0.5rem;
      }
    }
  }
  .live4 {
    background: url("../../assets/images/page50.jpg") repeat left top;
    background-size: 0.71rem auto;
    padding-bottom: 0.6rem;
    .title {
      font-size: 0.52rem;
      line-height: 1.8rem;
      text-align: center;
      padding-bottom: 0.2rem;
    }
    .item {
      width: 10rem;
      margin: 0 auto 0.3rem;
      background-color: #fff;
      border-radius: 0.2rem;
      padding: 0.6rem 0.45rem;
      .t1 {
        text-align: center;
        span {
          font-size: 0.48rem;
          color: #000;
          font-family: Arial, Helvetica, sans-serif;
          display: inline-block;
          vertical-align: middle;
          font-weight: 600;
          padding: 0 0.2rem;
        }
        i {
          display: inline-block;
          vertical-align: middle;
          width: 0.3rem;
          height: 2px;
          background-color: #000;
        }
      }
      .t2 {
        text-align: center;
        img {
          width: 6.3rem;
        }
      }
      .t3 {
        padding: 0.2rem 0;
        font-size: 0.4rem;
        color: #000;
      }
      .t4 {
        font-size: 0.36rem;
        display: flex;
        line-height: 0.6rem;
        padding-bottom: 0.1rem;
        span {
          font-size: 0.36rem;
          color: #1566fb;
          width: 1.8rem;
        }
        p {
          flex: 1;
          color: #666;
        }
        b {
          flex: 1;
          font-weight: 500;
          color: #ffae00;
        }
      }
    }
  }
  .live5 {
    .list5 {
      width: 10rem;
      height: 6.8rem;
      background: url("../../assets/images/page54.png") repeat left top;
      background-size: 1.07rem 0.54rem;
      margin: auto;
      padding-top: 0.9rem;
      border-radius: 0.2rem;
      h2 {
        height: 0.67rem;
        background: url("../../assets/images/page53.png") no-repeat center top;
        background-size: 5.35rem;
        margin-top: -1.4rem;
        text-align: center;
        color: #fff;
        font-size: 0.4rem;
        line-height: 0.67rem;
        font-weight: 400;
      }
      h3 {
        padding-top: 0.9rem;
        img {
          width: 100%;
        }
      }
      h4 {
        font-size: 0.4rem;
        font-weight: 500;
        padding: 0.3rem 0.5rem;
      }
      h5 {
        font-weight: 400;
        font-size: 0.34rem;
        padding: 0 0.5rem;
        line-height: 0.55rem;
        color: #666;
        min-height: 2.2rem;
      }
      h6 {
        font-weight: 500;
        color: #0a7aeb;
        text-align: right;
        font-size: 0.34rem;
        padding-right: 0.5rem;
        line-height: 0.55rem;
        margin-top: -0.55rem;
      }
    }
  }
  .live6 {
    padding: 0.3rem 0;
    background-color: #fff;
    .title {
      font-size: 0.52rem;
      text-align: center;
    }
    .list6 {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 33.333333%;
        text-align: center;
        padding-top: 0.8rem;
        &:nth-of-type(n + 4) {
          width: 50%;
        }
        img {
          width: 2rem;
        }
        span {
          display: block;
          font-size: 0.36rem;
          padding-top: 0.4rem;
        }
      }
    }
  }
  .live7 {
    .title {
      padding-top: 0.7rem;
      padding-bottom: 0.5rem;
    }
    .list7 {
      padding: 0.4rem;
      li {
        margin-bottom: 0.3rem;
        border: 1px solid #eee;
        border-radius: 0.1rem;
        padding: 0.8rem 0.4rem;
        display: flex;
        align-items: center;
        img {
          width: 2rem;
        }
        span {
          font-size: 0.48rem;
        }
        p {
          font-size: 0.36rem;
          color: #666;
          padding-top: 0.1rem;
        }
      }
    }
  }
  .live8 {
    background-color: #fff;
    .title {
      text-align: center;
      span {
        font-size: 0.52rem;
      }
      p {
        font-size: 0.34rem;
        color: #666;
        padding: 0.2rem 0;
      }
    }
    .item{
        width: 10rem;
        background-color: #fff;
        margin: auto;
        box-shadow: 0px 5px 29px 0px rgba(214, 214, 214, 0.69);
        border-radius: .1rem;
        padding: .6rem .2rem;
        h2{
            font-size: .48rem;
            padding: 0 .3rem;
        }
        p{
            padding: .1rem .3rem;
            font-size: .34rem;
            color: #999;
            line-height: .55rem
        }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/view/product/interactionLive.vue